import dayjs from 'dayjs';
import { Bubble, Props as BubbleProps } from './Bubble';
import { Message } from '@raysee/schema';

interface Props extends BubbleProps {
  isAlreadyCalled?: Message;
}

export const CallBubble = ({ isAlreadyCalled, ...props }: Props) => {
  const onCall = () => {
    if (!props.message.canCall) {
      alert('無効なルームから電話をかけようとしています。');
      return;
    }
    props.onSend('通話開始');
  };

  return (
    <Bubble {...props}>
      <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
        <p className="leading-5 text-white">
          鑑定開始時間です
          <br />
          {props.role === 'teller'
            ? 'ユーザーから電話がかかってきます'
            : 'こちらから電話をかけてください'}
        </p>
        {props.role === 'user' && (
          <p className="text-white underline hover:cursor-pointer" onClick={onCall}>
            電話をかける
          </p>
        )}
        {props.role === 'teller' &&
          dayjs().isAfter(dayjs(props.message.createTime).add(3, 'minutes')) &&
          !isAlreadyCalled && (
            <p className="text-white underline hover:cursor-pointer" onClick={onCall}>
              電話をかける
            </p>
          )}
      </div>
    </Bubble>
  );
};
